
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_1ime1_94",
  "focus-lock": "awsui_focus-lock_145pa_1ime1_105",
  "calendar": "awsui_calendar_145pa_1ime1_109",
  "date-picker-container": "awsui_date-picker-container_145pa_1ime1_122",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_1ime1_127",
  "date-picker-input": "awsui_date-picker-input_145pa_1ime1_131",
  "open-calendar-button": "awsui_open-calendar-button_145pa_1ime1_136"
};
  